import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M19.116 18.936C19.116 19.132 19.052 19.178 18.87 19.1761C18.028 19.168 17.185 19.168 16.344 19.1761C16.155 19.178 16.096 19.118 16.097 18.93C16.103 17.358 16.109 15.787 16.095 14.215C16.092 13.82 16.057 13.417 15.971 13.032C15.815 12.34 15.368 12.006 14.656 11.998C14.44 11.995 14.217 12.005 14.009 12.057C13.317 12.228 13.02 12.75 12.904 13.396C12.848 13.707 12.827 14.027 12.826 14.343C12.818 15.871 12.823 17.399 12.823 18.927C12.823 19.171 12.822 19.172 12.572 19.172C11.73 19.173 10.887 19.168 10.045 19.1761C9.859 19.178 9.8 19.124 9.8 18.933C9.806 15.895 9.804 12.858 9.804 9.821C9.804 9.577 9.805 9.577 10.053 9.577C10.865 9.577 11.676 9.581 12.487 9.573C12.657 9.571 12.717 9.62 12.711 9.794C12.699 10.136 12.707 10.479 12.707 10.822C13.034 10.361 13.424 9.983 13.917 9.718C14.815 9.263 16.081 9.345 16.929 9.525C18.297 9.895 19.116 11.451 19.116 13.474C19.116 15.304 19.108 17.115 19.116 18.936ZM6.478 8.295C5.514 8.295 4.747 7.53 4.746 6.568C4.745 5.594 5.512 4.824 6.483 4.824C7.447 4.824 8.22 5.603 8.218 6.573C8.217 7.529 7.444 8.295 6.478 8.295ZM7.993 18.965C7.993 19.116 7.949 19.176 7.792 19.175C6.919 19.17 6.046 19.169 5.173 19.175C5.002 19.177 4.96898 19.107 4.96898 18.952C4.974 17.424 4.972 15.897 4.972 14.37C4.972 12.849 4.975 11.328 4.96898 9.807C4.968 9.631 5.01 9.57 5.195 9.57195C6.055 9.582 6.916 9.58 7.777 9.574C7.936 9.57195 7.994 9.613 7.994 9.782C7.99 12.843 7.99 15.904 7.993 18.965ZM20.01 2H3.991C2.891 2 2 2.892 2 3.991V20.01C2 21.109 2.891 22 3.991 22H20.01C21.109 22 22 21.109 22 20.01V3.991C22 2.892 21.109 2 20.01 2Z", clipRule: "evenodd" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconSocialLinkedin = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconSocialLinkedin.displayName = "IconSocialLinkedin";

export { IconSocialLinkedin };
